import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import styles from './styles/Home.module.css';

function Home() {
  const navigate = useNavigate();

  const usuario = localStorage.getItem('usuario');
  const permissoes = JSON.parse(localStorage.getItem('permissoes'));

  return (
    <div className={styles.body}>
      <Header />

      {permissoes.admin && (
        <div className={styles.permissoesUsuarios}>
          <button onClick={() => navigate('/usuarios')}>
            <i className="fa-solid fa-users-gear"></i>
            <p>Usuários</p>
          </button>
        </div>
      )}

      <h2>Olá <span>{usuario}</span>!</h2>

      <div className={styles.container}>
        {permissoes.paginas.produtos && (
          <button onClick={() => navigate('/produtos')}>
            <img src="images/common/diamante.svg" alt="" />
            <p>Produtos</p>
          </button>
        )}

        {permissoes.paginas.estoques && (
          <button onClick={() => navigate('/estoques')}>
            <img src="images/common/caixa.svg" alt="" />
            <p>Estoques</p>
          </button>
        )}

        {permissoes.paginas.compras && (
          <button onClick={() => navigate('/distribuicoes')}>
            <img src="images/common/caminhao.svg" alt="" />
            <p>Distribuições</p>
          </button>
        )}

        {permissoes.paginas.vendas && (
          <button onClick={() => navigate('/vendas')}>
            <img src="images/common/dinheiro.svg" alt="" />
            <p>Vendas</p>
          </button>
        )}

        {permissoes.paginas.solicitacoes_distribuicao && (
          <button
            onClick={() => navigate('/solicitacoes_distribuicao')}
          >
            <img src="images/common/solicitacoesDistribuicao.png" alt="" />
            <p>Solicitações de Distribuição</p>
          </button>
        )}

        {permissoes.paginas.distribuicoes_vendas && (
          <button
            onClick={() => navigate('/giro_estoque')}
          >
            <img src="images/common/giro_estoque.png" alt="" />
            <p>Giro de Estoque</p>
          </button>
        )}

        {/* Exemplo de botão com badge "Novo" */}
        {/* {permissoes.paginas.pedidos && (
          <button
            onClick={() => navigate('/pedidos')}
            className={styles.botaoNovo}
          >
            <span className={styles.badgeNovo}>Novo</span>

            <img src="images/common/pedidos.ico" alt="" />
            <p>Pedidos</p>
          </button>
        )} */}

        {permissoes.paginas.pedidos && (
          <button onClick={() => navigate('/pedidos')}>
            <img src="images/common/pedidos.ico" alt="" />
            <p>Pedidos</p>
          </button>
        )}

        {permissoes.paginas.pedidos_expedicao && (
          <button onClick={() => navigate('/pedidos_expedicao')}>
            <img src="images/common/anotacao.ico" alt="" />
            <p>Pedidos Expedição</p>
          </button>
        )}

        {permissoes.paginas.arquivos && (
          <button onClick={() => navigate('/arquivos')}>
            <img src="images/common/nuvem.svg" alt="" />
            <p>Arquivos</p>
          </button>
        )}
      </div>
    </div>
  );
}

export default Home;